import React from "react";
import { Row, Col, Card } from "antd";
import Navbar from "./Navbar";
import { HomeWrapper } from "./styled";
import { CustomButton } from "../physician_page/styled";
const HomePage = () => {
  return (
    <HomeWrapper>
      <Navbar />
      <Row
        className="d-flex justify-start"
        style={{
          background:
            "url('/meducate-bg-banner.PNG') no-repeat center center / cover",
          height: "90%",
        }}
      >
        <Col style={{ padding: "0 60px" }}>
          <Card>
            <Col
              className="font-bold mb-15"
              style={{ fontSize: "60px", width: "630px", color: "#ffffff" }}
            >
              Personalized Medical Education
            </Col>
            <Col
              className="font-18 mb-15"
              style={{ width: "500px", color: "#ffffff" }}
            >
              Access tailored medical education videos and improve patient
              communication with our AI-powered platform.
            </Col>
            <Col>
              {/* <CustomButton>Browse Videos</CustomButton> */}
            </Col>
          </Card>
        </Col>
      </Row>
    </HomeWrapper>
  );
};

export default HomePage;
